import { render, staticRenderFns } from "./PaymentCardsCard.vue?vue&type=template&id=c0d2d06a&"
import script from "./PaymentCardsCard.vue?vue&type=script&lang=js&"
export * from "./PaymentCardsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports